import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { LayoutPlain, Header, ElevatedButton } from 'components/layout'
import { meta, modal } from 'helpers/decorators'
import { Button, Note, Title } from '../../../components/misc'
import { connect } from 'react-redux'
import { get } from 'lodash'
import QRCode from 'react-qr-code'
import MfaCodeModal from '../../../components/modals/MfaCodeModal/MfaCodeModal'
import MODALS from '../../../constants/layout/modals'
import MODAL from '../../../constants/layout/modals'
import styles from './mfa-qr-code.styl'
import { FormattedMessage } from 'react-intl'
import config from '../../../config'
import { push } from 'connected-react-router'
import { ChooseRole } from '../../misc'

@meta({ title: 'MFA authentication', intlKey: 'route.mfa_authentication' })
@modal.trigger()
@connect(
  ({ auth }) => ({
    user: get(auth, 'user')
  }), { push }
)
class MfaQRCode extends Component {
  static propTypes = {
    user: PropTypes.object,
    onOpen: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired
  }

  handleOpenModal = () => {
    this.props.onOpen(MODAL.SET_MFA_CODE, null, null)
  }

  render () {
    const { user } = this.props

    const key = get(user, 'secret')

    return (
      <LayoutPlain greyBg header={<Header />}>
        <div className={styles.wrapper}>

          {key && <div>
            <Title h1 intlKey="moduleTitle.mfa_scan_qr_title" className="base-margin--top">
              You need to open your authenticator
            </Title>

            <Note hideNodePrefix={true} margin="10 0 10px 0">
              <FormattedMessage
                id="label.mfa_scan_qr"
                defaultMessage="Please scan QR code."
              />
            </Note>

            <div style={{marginTop: "40px"}}>
              <QRCode value={key} />
            </div>

            <div className={styles.continue}>
              <ElevatedButton
                rounded
                submit
                padded
                intlKey="button.continue"
                inline
                onClick={this.handleOpenModal}
              >
                Continue
              </ElevatedButton>
            </div>
          </div>}

          {!key && <div>
            <div className="container">
              <div style={{ paddingTop: 100 }} className="text--center">
                <Title h1 intlKey="moduleTitle.mfa_missing_code" className="base-margin--top">
                  Something gets wrong, please login
                </Title>
                <Button onClick={() => this.props.push(`${config.publicPath}/`)}>
                  <FormattedMessage id="button.login" defaultMessage="Login" />
                </Button>
              </div>
            </div>
          </div>}
        </div>
          <MfaCodeModal modalId={MODALS.SET_MFA_CODE} />
          <ChooseRole />
      </LayoutPlain>
    )
  }
}

export default MfaQRCode
